import React from 'react';
import PropsTypes from 'prop-types';
import { LayoutWrapperStyled as LayoutWrapper } from './styles/IdentityValidationStyled';

const IdentityValidationLayout = ({ children }) => (
  <LayoutWrapper>{children}</LayoutWrapper>
);

IdentityValidationLayout.propTypes = {
  children: PropsTypes.node.isRequired,
};

export default IdentityValidationLayout;
